import rootService from 'core/services.root';

export default rootService({
    fetchProfessional: ['GET', '/doctor/:id'],
    getProfessionalsList: ['GET', '/doctor/listing'],
    notifyProfessional: ['POST', '/doctor/socket/validate/:doctor_id'],
    postProfessional: ['POST', '/doctor/store'],
    postProfessionalExternalLogin: ['POST', '/doctor/login/external'],
    putProfessional: ['PUT', '/doctor/update/:doctor_id'],
    removeProfessional: ['DELETE', '/doctor/delete/:doctor_id'],
    setEnabled: ['POST', '/doctor/enable'],
    uploadAvatar: ['POST', '/user/avatar/upload', { headers: { 'content-type': 'multipart/form-data' } }],
    uploadSignAndStamp: ['POST', '/doctor/sign/upload/:doctor_id', { headers: { 'content-type': 'multipart/form-data' } }]
});
